import styled from 'styled-components'
import { SubTitle } from '../ui/text'

export const Card = styled.article`
  flex: 0 0 calc((100% - 32px) / 3);
  max-width: 350px;
  scroll-snap-align: start;
  border: 1px solid ${props => props.theme.colors.greys.dividerGray};
  border-radius: 16px;
  overflow: hidden;
  background-color: ${props => props.theme.colors.brand.white};
  cursor: ${props => (props.$clickable ? 'pointer' : 'default')};
  transition: box-shadow 0.2s, border-color 0.2s;

  ${props =>
    props.$clickable &&
    `
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      border-color: ${props.theme.colors.greys.cardHoverBorder};
    }
  `}

  @media (max-width: ${props => props.theme.sizes.breakPoints.medium}) {
    flex: 0 0 calc((100% - 16px) / 2);
  }

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    flex: 0 0 100%;
  }
`

export const CardBanner = styled.div`
  width: 100%;
  aspect-ratio: 398 / 117;
  background-image: ${props =>
    props.$backgroundImage
      ? `url(${props.$backgroundImage})`
      : `linear-gradient(120deg, ${props.theme.colors.brand.backgroundBlue} 0%, #D0E2FF 100%)`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: ${props => (props.$backgroundImage ? 'contain' : 'cover')};
  background-color: ${props => props.theme.colors.brand.white};
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 14px;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`

export const CardSubtitle = styled(SubTitle)`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.$lineClamp || 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CarouselShell = styled.div`
  position: relative;
`

export const CarouselViewport = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const CarouselTrack = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

export const CarouselNavButton = styled.button`
  position: absolute;
  top: 50%;
  ${props => props.$position}: -14px;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.colors.greys.defaultBorder};
  background-color: ${props => props.theme.colors.brand.white};
  color: ${props => props.theme.colors.brand.blueOmint};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
  box-shadow: 0 0px 8px -2px rgba(0, 0, 0, 0.25);

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    box-shadow: none;
  }

  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    display: none;
  }
`
